import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

interface IScreenInitialState {
  [screenName: string]: any; // eslint-disable-line
}

interface IUpdateColAction {
  screenName: string;
  screenState: any; // eslint-disable-line
}

const initialState: IScreenInitialState = {};

export const screenStateSlice = createSlice({
  name: 'screenState',
  initialState,
  reducers: {
    updateCurrentState: (state, { payload: { screenName, screenState } }: PayloadAction<IUpdateColAction>) => {
      state[screenName] = screenState;
    },
    resetState: (_state) => initialState,
  },
});

export const { updateCurrentState, resetState } = screenStateSlice.actions;

export const selectCurrentState =
  (screenName = '') =>
  (state: RootState) =>
    state.screenState[screenName];
